import { Component, OnInit, OnDestroy} from "@angular/core";
import { Subject } from 'rxjs';
import { envName } from "../../../environments/environment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  
  private readonly _destroying$ = new Subject<void>();

   constructor(
   ) { }

  ngOnInit() {
    console.log("env: ", envName);
    
  }

 
  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
